import { render, staticRenderFns } from "./kToj_index_buJia.vue?vue&type=template&id=5413d04a&scoped=true&"
import script from "./kToj_index_buJia.vue?vue&type=script&lang=js&"
export * from "./kToj_index_buJia.vue?vue&type=script&lang=js&"
import style0 from "./kToj_index_buJia.vue?vue&type=style&index=0&id=5413d04a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5413d04a",
  null
  
)

export default component.exports